












































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import XLSX from "xlsx";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'items',
    ]),
    ...mapGetters(STORE_KEY, [
      'rows'
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    TitleBar
  }
})
export default class WarehouseByTransactionsReport extends Vue {
  warehouse_id: any = null;
  targetDates: any[] = [];
  rows!: any[];
  openedDetails: any[] = [];

  get titleStack () {
    return [
      'Отчеты',
      'Отчет по движению товаров'
    ]
  }

  localFilter = {
    dZoneGroups: null,
    targetDates: [new Date(), new Date()],
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.$route.query.warehouse_id) {
      this.warehouse_id = this.$route.query.warehouse_id
    }

    // @ts-ignore
    this.targetDates = (this.$route.query && this.$route.query.since) ? [moment(this.$route.query.since).toDate(), moment(this.$route.query.until).toDate()] : [new Date(), new Date()];

    this.handleParamsChange();
  }
  expandAllWarehouses() {
    this.rows.map((row: any) => {
      console.log(row);
      // @ts-ignore
      this.$refs.table.openDetailRow(row)
    })
  }
  collapseAllWarehouses() {
    this.rows.map((row: any) => {
      // @ts-ignore
      this.$refs.table.closeDetailRow(row)
    })
  }

  tableToExcel() {
    this.$store.dispatch(`${STORE_KEY}/exportData`).then((csvContent: any[]) => {
      const ws = XLSX.utils.aoa_to_sheet(csvContent);
      // @ts-ignore
      const range = XLSX.utils.decode_range(ws['!ref']);
      for(let R = range.s.r; R <= range.e.r; ++R) {
        for(let C = range.s.c; C <= range.e.c; ++C) {
          const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
          if(!ws[cellref] || C < 4 || R < 1) continue; // if cell doesn't exist, move on
          const cell = ws[cellref];
          cell.t = 'n'
          cell.z = '0.00'
        }
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Отчет");
      XLSX.writeFile(wb, 'export.xlsx')
    })
  }

  onWarehouseChange(warehouse_id: string) {
    if (warehouse_id) {
      this.$router.replace({
        query: { ...this.$route.query, warehouse_id }
      })
    }
  }

  onDatesChange(dates: any) {
    console.log('onDatesChange', dates)
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    if (this.$route.query && this.$route.query.warehouse_id) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
    }
  }

}
